import { render, staticRenderFns } from "./CourseDetailImageForm.vue?vue&type=template&id=f31f6fb4&scoped=true"
import script from "./CourseDetailImageForm.vue?vue&type=script&lang=js"
export * from "./CourseDetailImageForm.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailImageForm.vue?vue&type=style&index=0&id=f31f6fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31f6fb4",
  null
  
)

export default component.exports